import { CalendarCheck } from 'lucide-react'
import { SchedulingSpaceFields } from '@/components/features/scheduling/SchedulingSpaceFields'
import { defaultSchedulingConfig, schedulingConfigApiErrors } from '@/components/features/scheduling/schedulingConfig'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const SchedulingPage = lazyPage(() => import('@/pages/Scheduling'), 'SchedulingPage')
const SchedulingHostPage = lazyPage(() => import('@/pages/SchedulingHost'), 'SchedulingHostPage')

export const schedulingModule: ModuleDefinition = {
  key: 'scheduling',
  icon: CalendarCheck,
  iconName: 'calendar-check',
  namespaces: ['scheduling', 'bookings'],
  ready: true,
  ListPage: SchedulingPage,
  renderDetail: ({ spaceData }) => <SchedulingHostPage spaceData={spaceData} />,
  /* Who may offer hours and whether they may charge: a step of its own (PADROES-UI section 14). */
  setup: {
    wizardStep: 'own',
    stepLabelKey: 'scheduling:config.stepLabel',
    stepHintKey: 'scheduling:config.stepHint',
    defaultConfig: () => defaultSchedulingConfig(),
    validate: () => null,
    errorsFromApi: (err) => schedulingConfigApiErrors(err),
    Fields: SchedulingSpaceFields,
    persist: {
      type: 'moduleConfig',
      /* What this screen owns replaces its keys; anything else the space stored goes back untouched. */
      toModuleConfig: (config, stored) => ({
        ...(stored || {}),
        scheduling: { ...(stored?.scheduling || {}), ...config }
      }),
      fromSpace: (space) => ({ ...defaultSchedulingConfig(), ...(space.moduleConfig?.scheduling ?? {}) })
    }
  }
}
